import {animate, state, style, transition, trigger} from '@angular/animations';
import {AsyncPipe, NgTemplateOutlet} from '@angular/common';
import {Component, Input, ViewEncapsulation, inject, OnInit} from '@angular/core';
import {MatRippleModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {NgxPermissionsModule} from 'ngx-permissions';

import {NavAccordionItemDirective} from './nav-accordion-item.directive';
import {NavAccordionToggleDirective} from './nav-accordion-toggle.directive';
import {NavAccordionDirective} from './nav-accordion.directive';
import {Menu, MenuService} from "../../core";
import {SessionManager} from "../../manager/SessionManager";

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    RouterLink,
    RouterLinkActive,
    NgxPermissionsModule,
    MatIconModule,
    MatRippleModule,
    TranslateModule,
    NavAccordionDirective,
    NavAccordionItemDirective,
    NavAccordionToggleDirective,
  ],
  animations: [
    trigger('expansion', [
      state('collapsed, void', style({height: '0px', visibility: 'hidden'})),
      state('expanded', style({height: '*', visibility: ''})),
      transition(
        'expanded <=> collapsed, void => collapsed',
        animate('225ms cubic-bezier(0.4,0,0.2,1)')
      ),
    ]),
  ],
  providers: [SessionManager]
})
export class SidemenuComponent implements OnInit {
  // The ripple effect makes page flashing on mobile
  @Input() ripple = false;

  private readonly menu = inject(MenuService);

  menu$ = this.menu.getAll();

  buildRoute = this.menu.buildRoute;

  constructor(private sessionManager: SessionManager) {
  }

  ngOnInit() {
    this.menu.set([])
    this.menu.add(new Menu(
      "catalog",
      "Каталог",
      'link',
      "category")
    )

    this.menu.add(new Menu(
      "search",
      "Поиск",
      'link',
      "search")
    )

    if (this.sessionManager.isAuth()) {

      if (this.sessionManager.isAdmin() || this.sessionManager.isSuperAdmin()) {
        this.menu.add(new Menu(
          "admin/main",
          "Главная(Админ)",
          'link',
          "home")
        )

        this.menu.add(new Menu(
          "admin/category",
          "Каталог(Админ)",
          'link',
          "category")
        )

        this.menu.add(new Menu(
          "admin/product",
          "Продукты",
          'link',
          "settings_input_component")
        )


        this.menu.add(new Menu(
          "admin/user",
          "Пользователи",
          'link',
          "account_box")
        )

        this.menu.add(new Menu(
          "admin/search/history",
          "История поиска",
          'link',
          "history")
        )

        this.menu.add(new Menu(
          "admin/statistics",
          "Статистика",
          'link',
          "dashboard")
        )
      }

      if (this.sessionManager.isAdmin() || this.sessionManager.isSuperAdmin() || this.sessionManager.isManager()) {
        this.menu.add(new Menu(
          "admin/operation",
          "Касса",
          'link',
          "developer_board")
        )

        this.menu.add(new Menu(
          "admin/repairs",
          "Ремонт",
          'link',
          "settings")
        )
      }

    }


    // this.menu.add(new Menu(
    //   "statistic",
    //   "Статистика",
    //   'link',
    //   "bar_chart")
    // )
  }
}
